import type { LoLocal } from '../store/cuenta';

function plural(n: number, uno: string, varios: string): string {
  return `${n} ${n === 1 ? uno : varios}`;
}

/**
 * «214 días, 37 entradas y 4 hitos» — solo lo que hay, `null` si no hay nada. Es la
 * evidencia de «no se pierde nada» que enseñan la puerta y la pantalla de cuenta.
 */
export function resumenDeLoLocal(local: LoLocal | null, separador?: string): string | null {
  if (!local) return null;
  const partes = [
    local.dias > 0 ? plural(local.dias, 'día', 'días') : null,
    local.entradas > 0 ? plural(local.entradas, 'entrada', 'entradas') : null,
    local.hitos > 0 ? plural(local.hitos, 'hito', 'hitos') : null,
  ].filter((p): p is string => p !== null);
  const ultima = partes.pop();
  if (ultima === undefined) return null;
  if (separador) return [...partes, ultima].join(separador);
  return partes.length === 0 ? ultima : `${partes.join(', ')} y ${ultima}`;
}
